module.exports = __webpack_public_path__ + "img/jcxx.1de826cb.svg";